var map = {
	"./kolor-01.png": "4615",
	"./kolor-02.png": "1f4d",
	"./kolor-03.png": "47ae",
	"./kolor-04.png": "9dd6",
	"./kolor-05.png": "b24d",
	"./kolor-06.png": "fa7b",
	"./kolor-07.png": "5474",
	"./kolor-08.png": "dfed",
	"./kolor-09.png": "6711",
	"./kolor-10.png": "f8ae",
	"./kolor-11.png": "3fd8",
	"./kolor-12.png": "bbaf",
	"./kolor-13.png": "4426",
	"./kolor-14.png": "d5d6",
	"./kolor-15.png": "6845",
	"./kolor-16.png": "4b72",
	"./kolor-17.png": "d996",
	"./kolor-18.png": "16df",
	"./kolor-19.png": "e39f",
	"./kolor-20.png": "00f0",
	"./kolor-21.png": "73e3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5e56";